import ActionTypes from "./ActionTypes";

export const setOptions = (payload) => ({
  type: ActionTypes.SET_COMMUNICATION_HUB_OPTIONS,
  payload,
});
export const setOptionsLoading = (payload) => ({
  type: ActionTypes.SET_COMMUNICATION_HUB_OPTIONS_LOADING,
  payload,
});
